<div
  *appLoadingIndicator="{
    show: loading || themeLoading,
    fullPage: true,
    showBackdrop: true,
    size: Sizes.LARGE
  }"
></div>
<div class="noty-outlet"></div>
<router-outlet></router-outlet>
